import { createSlice } from '@reduxjs/toolkit';
import { planNames } from 'src/common/config/TextMessage';

const initialState = {
  subscription: null,
  premiumUser: false,
  isDIYUser: false,
  isAgency: false,
  isDesigner: false,
  isNewPlan: true,
  activePlan: '',
  planDetails: {
    free: planNames.free,
    pro: planNames.designer,
    agency: planNames.agency,
    expertPlus: planNames.expertPlus,
    diy: planNames.diy,
    designer: planNames.designer,
    localseo: planNames.localseo,
    enterprise: planNames.enterprise,
    starterPlus: planNames.starterPlus,
    proPlus: planNames.proPlus
  },
  squareSpaceProcess: {
    email: '',
    signUp: false
  },
  primePlan: [
    planNames.agency,
    planNames.expertPlus,
    'pro',
    planNames.designer,
    planNames.proPlus,
    planNames.enterprise
  ],
  isDowngradedWithSites: null,
  isLocalSeoPlan: false,
  isEnterprisePlan: false,
  stripeData: null,
  tempId: null
};

/**
 * Redux slice for managing counter-related state.
 *
 * @name userSlice
 * @type {Slice}
 */
// Action functions declaration
export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setStateStripeSubscription: (state, actions) => {
      state.subscription = actions.payload;
      let userDetails = actions.payload;
      if (!userDetails) {
        userDetails = {
          plan_name: planNames.free,
          scan: 0,
          used_scan: 0
        };
      }
      let planName = userDetails?.plan_name?.name?.toLowerCase();
      // If User is easting the allow in v2 feature
      let isNewPlan = userDetails?.plan_name?.new_subscription || true;
      if (isNewPlan == 'false' && (planName == planNames.agency || planName == planNames.expertPlus)) {
        planName = planNames.designer;
      }
      // end
      state.isDIYUser = planName == planNames.diy || planName == planNames.starter || planName == planNames.starterPlus;
      state.premiumUser = planName != planNames.free;
      state.isAgency = planName == planNames.agency || planName == planNames.expertPlus;
      state.isDesigner = planName == planNames.designer || planName == planNames.proPlus;
      state.isLocalSeoPlan = planName == planNames.localseo;
      state.isEnterprisePlan = planName == planNames.enterprise;
      state.activePlan = planName;
      state.isNewPlan = isNewPlan;
    },
    setSquareSpaceSignUp: (state, actions) => {
      state.squareSpaceProcess = actions.payload;
    },
    setIsPremiumUser: (state, actions) => {
      let planName = actions.payload;
      state.premiumUser = planName != planNames.free;
    },
    setIsDowngradedWithSites: (state, actions) => {
      state.isDowngradedWithSites = actions.payload;
    },
    setStripeData: (state, actions) => {
      state.stripeData = actions.payload;
    },
    setTempId: (state, actions) => {
      state.tempId = actions.payload;
    },
    userCleanupInitialState: () => initialState
  }
});

// Action creators are generated for each case reducer function
export const {
  setStateStripeSubscription,
  userCleanupInitialState,
  setSquareSpaceSignUp,
  setIsPremiumUser,
  setIsDowngradedWithSites,
  setStripeData,
  setTempId
} = userSlice.actions;

export default userSlice.reducer;
